export default __webpack_public_path__ + "static/media/childDevelopmnet-blob4.32a1c032.svg";